module.exports = __webpack_public_path__ + "static/media/mastercard.39748d61.svg";